export const headers = [
  { content: "Property" },
  { content: "Inncode" },
  { content: "Brand" },
  { content: "Leader Plans" },
  { content: "Team Plans" },
  { content: "Engagement" }
];
